export const TRANSFER_PAYMENT_SUCCESS = 'TRANSFER_PAYMENT_SUCCESS'
export const TRANSFER_PAYMENT_REQUEST = 'TRANSFER_PAYMENT_REQUEST'
export const TRANSFER_PAYMENT_FAILURE = 'TRANSFER_PAYMENT_FAILURE'
